"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";

class NliraCustomBrand extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
    this._logoDataUri = null;
  }

  static getModelClassName() {
    return "NliraCustomBrand";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/nlira-custom-brands"
    );
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/nlira-custom-brands/" +
      this.id
    );
  }

  getAdminPath() {
    console.error("Cannot go to a Custom Brand.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return this.createdAt;
  }

  get searchResultStatus() {
    return null;
  }

  /**** HELPER ADDITIONS ********/
  static getBrandByProspectUuid(prospectUuid) {
    let request =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/" +
      prospectUuid +
      "/nlira-custom-brand";

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", request).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getBrandByPartnerSourceUuid(partnerSourceUuid) {
    let request =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/next-level-partner-sources/" +
      partnerSourceUuid +
      "/nlira-custom-brand";

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", request).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getLogo(id) {
    let request =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/nlira-custom-brands/" +
      id +
      "/logo";

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", request).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getLinkedEntities(id) {
    let request =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/nlira-custom-brands/" +
      id +
      "/linked-entities";

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", request).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static async create(data) {
    if (!data.displayName || !data.logoStoredFile) {
      throw new Error("IRA name and logo are required");
    }

    let request =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/nlira-custom-brands";

    let formData = new FormData();
    formData.append("displayName", data.displayName);
    formData.append("logoStoredFile", data.logoStoredFile);

    if (data.emailAddress) {
      formData.append("emailAddress", data.emailAddress);
    }
    if (data.phoneNumber) {
      formData.append("phoneNumber", data.phoneNumber);
    }
    if (data.reportPortalUrl) {
      formData.append("reportPortalUrl", data.reportPortalUrl);
    }

    return new Promise((resolve, reject) => {
      ApiRequest.upload(request, formData).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  async update() {
    let request = this.getApiPathForRefreshUpdateAndDelete();
    let formData = new FormData();
    let attributesToUpdate = this.getDirtyAttributes();

    if (Object.keys(attributesToUpdate).length === 0) return;

    Object.keys(attributesToUpdate).forEach((key) => {
      formData.append(key, attributesToUpdate[key]);
    });

    return new Promise((resolve, reject) => {
      ApiRequest.send("PATCH", request, formData).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }
}

export default NliraCustomBrand;
